import React, {useState, useEffect} from 'react';
import { getAuth, signInWithPopup, GoogleAuthProvider, signOut, onAuthStateChanged } from 'firebase/auth';
import { app } from './firebase'; // Import the initialized Firebase app

const auth = getAuth(app); // Initialize the auth instance
const googleAuthProvider = new GoogleAuthProvider(); // Initialize the Google Auth Provider

const LoginPage = (props) => {
  const [userDisplayName, setUserDisplayName] = useState(props.userDisplayName);
  const [userPicture, setPicture] = useState(props.userPicture);
  const [shouldSignIn, setShouldSignIn] = useState(true); // State to control sign-in process

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
    if (user) {
      // User is signed in, bypass the login
      //console.log('User is already signed in:', user);
      props.handleSetUserId(user.uid);
      setUserDisplayName(user.displayName);
      setPicture(user.photoURL);
      setShouldSignIn(false); // Prevent automatic sign-in
    } else {
      // No user is signed in, proceed with Google sign-in if shouldSignIn is true
      if (shouldSignIn) {
        handleGoogleSignIn();
      }
    }
  });
  // Cleanup subscription on unmount
  return () => unsubscribe();
  },[shouldSignIn]);
  const handleGoogleSignIn = async () => {
    try {
      const result = await signInWithPopup(auth, googleAuthProvider);
      // This gives you a Google Access Token. You can use it to access the Google API.
      const credential = GoogleAuthProvider.credentialFromResult(result);
      const token = credential.accessToken;
      // The signed-in user info.
      const user = result.user;
      // console.log('User:', user);
      // console.log('Token:', token);
      // console.log('User:', user);
      props.handleSetUserId(user.uid);
      setUserDisplayName(user.displayName);
      setPicture(user.photoURL); 
    } catch (error) {
      // Handle Errors here.
      const errorCode = error.code;
      const errorMessage = error.message;
      // The email of the user's account used.
      const email = error.customData.email;
      // The AuthCredential type that was used.
      const credential = GoogleAuthProvider.credentialFromError(error);
      console.error('Error:', errorCode, errorMessage, email, credential);
    }
  };
  const handleGoogleSignOut = async () => {
    try {
      await signOut(auth);
      console.log('User signed out');
      props.handleSetUserId("");
      setUserDisplayName();
      setPicture(); 
      setShouldSignIn(false); // Prevent automatic sign-in
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };
  return (
    <div>
      {userDisplayName ? <span><span>{userDisplayName}</span> <img src={userPicture} alt="usrImage" height="25px"></img> <button  size="sm" onClick={handleGoogleSignOut}>Logout</button> </span> : <button size="sm" onClick={handleGoogleSignIn}>Login</button>}
    </div>
  );
};

export default LoginPage;